import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BG_PAGE, BRAND, NIGHT, FONT_STACK, CONTAINER } from "../tokens";

export default function CurvedCloser() {
  const navigate = useNavigate();
  return (
    <section style={{ background: BG_PAGE }}>
      <svg style={{ display: "block", width: "100%", height: 90 }} viewBox="0 0 1440 90" preserveAspectRatio="none">
        <path d="M0,90 Q720,-20 1440,90 Z" fill={BRAND} />
      </svg>
      <div style={{ background: BRAND, color: "#FFFFFF", padding: "20px 0 120px", textAlign: "center" }}>
        <div style={CONTAINER}>
          <h2 style={{ fontSize: "clamp(40px, 5vw, 64px)", fontWeight: 800, color: "#FFFFFF", letterSpacing: "-0.025em", lineHeight: 1.1, margin: "0 auto 36px", maxWidth: 900 }}>
            Hours in, pay out. It really is that simple.
          </h2>
          <button onClick={() => navigate("/pricing")} style={{ background: NIGHT, color: "#FFFFFF", fontSize: 16, fontWeight: 700, padding: "16px 32px", border: "none", borderRadius: 10, cursor: "pointer", fontFamily: FONT_STACK, display: "inline-flex", alignItems: "center", gap: 9 }}>
            Get started <ArrowRight size={17} />
          </button>
          <div style={{ marginTop: 24 }}>
            <a href="#" onClick={(e) => e.preventDefault()} style={{ fontSize: 12, color: "rgba(255,255,255,0.75)", textDecoration: "underline" }}>
              Important offers, pricing details, and disclaimers
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}